export class ProjectLocation
{
    public id: string = '';
    public parentId: string = '';
    public name: string = '';

    public static fromAutodeskJSON(json: any): ProjectLocation
    {
        let location = new ProjectLocation();
        location.id = json.id;
        location.parentId = json.parentId;
        location.name = json.name;

        return location;
    }
}
